import { __rest } from "tslib";
import React from 'react';
import Box from './Box';
/** @type {any} */
const Position = React.forwardRef((_a, ref) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement(Box, Object.assign({ position: "relative", ref: ref }, props), children));
});
export default Position;
